<template>
  <header
    :style="{
      justifyContent: $store.deviceStartData.firm_style
        .registrator_logo_in_center
        ? 'center'
        : 'flex-start',
      backgroundColor: $store.registratorBackgroundTopColor,
    }"
  >
    <img class="company-logo" :src="$store.companyLogoImage" />
    <LanguageDropdown
      v-if="showLanguageDropdown && languages.length > 1"
      class="languages-dropdown"
      :selected-item="activeLanguage"
      :languages="languages"
      @selectItem="selectLanguage($event)"
    />
  </header>
</template>

<script>
import LanguageDropdown from './LanguageDropdown';

export default {
  components: {
    LanguageDropdown,
  },
  computed: {
    languages() {
      return this.$store.deviceStartData.languages.filter(
        (language) => language.is_enabled,
      );
    },
    activeLanguage() {
      return this.languages.find(
        (language) => language.tag === this.$store.activeLanguage,
      );
    },
    showLanguageDropdown() {
      return this.$store.deviceStartData.unit_settings
        .show_lang_selecting_on_header;
    },
  },
  methods: {
    selectLanguage(language) {
      this.$store.currentLanguage = language;
      this.$languageService.changeLanguage(language.tag);
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 2.5vw;
  padding-top: 48px;
  position: relative;
  z-index: 4;

  .company-logo {
    width: 400px;
    object-fit: contain;
  }

  .languages-dropdown {
    position: absolute;
    right: 0;
    height: 100%;
    min-width: 158px;
  }
  // @media (min-width: 445px) {
  //   .languages-dropdown {
  //     position: relative !important;
  //   }
  // }
}

@media (max-width: 645px) {
  header {
    padding-top: 10px;
    .languages-dropdown {
      min-width: 110px;
    }
  }
  .dropdown-component {
    font-size: 22px;
  }
}

.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--label-secondary);
  z-index: 3;
}
</style>
